export const headersInitialState = {
  isLoading: false,
  isError: null,
  headers: {}
};
